import deviceEdit from './edit.vue'
import deviceList from './list.vue'//库存中
import EmptycodeList from './EmptycodeList.vue'//空码
import deviceretrievalList from './retrievallist.vue'//出库中
import devicedamageList from './damagelist.vue'//已损坏
import devicescrapList from './scraplist.vue'//已报废
import devicestandbyList from './standbylist.vue'//已报废
import * as devicedamage from './damage.vue'
import * as devicecheckout from './checkout.vue'
import * as devicescrap from './scrap.vue'
import * as devicewarehousing from './warehousing.vue'
import * as deviceimage from './image.vue'
import deviceInfoTime from './infotime.vue'
// import timeline from './timeline.vue'


import * as deviceClass from './deviceClass'
import * as scene from './scene'
import * as deviceRecord from './deviceRecord'
import * as deviceType from "./deviceType"
import * as firstCheck from './firstCheck'



let a = Object.assign({ deviceEdit, EmptycodeList, deviceList, deviceretrievalList, devicedamageList, devicescrapList, deviceInfoTime, devicestandbyList }, firstCheck, deviceClass, deviceRecord, scene, deviceType, devicedamage, devicecheckout, devicescrap, devicewarehousing, deviceimage)
export default a
